import React from "react";

import withObjectFitSupportDetection from "../../hocs/withObjectFitSupportDetection";
import config from "../../../config";

const defaultImagePath = config.portalId === "jdc" ? "/images/home/jdc/" : "/images/home/default/";

const HeroImage = ({
  objectFit = "object-cover",
  pin = "pin",
  bgColor = "bg-blue-grey",
  bgPosition = "bg-center",
  imagePath = defaultImagePath,
  altText = "Frau im Cabrio",
  classNames,
  objectFitSupported,
}) => (objectFitSupported ? (
  <picture
    className={`absolute block h-full xxs:h-auto z--10 ${bgColor} ${pin} ${
        classNames ? classNames.join(" ") : ""
      }`}
  >
    <source
      srcSet={`${imagePath}hero_2560px.webp, ${imagePath}hero_2560px@2x.webp 2x`}
      media="(min-width: 2560px)"
      type="image/webp"
    />
    <source
      srcSet={`${imagePath}hero_2560px.jpg, ${imagePath}hero_2560px@2x.jpg 2x`}
      media="(min-width: 2560px)"
      type="image/jpeg"
    />
    <source
      srcSet={`${imagePath}hero_1920px.webp, ${imagePath}hero_1920px@2x.webp 2x`}
      media="(min-width: 1920px)"
      type="image/webp"
    />
    <source
      srcSet={`${imagePath}hero_1920px.jpg, ${imagePath}hero_1920px@2x.jpg 2x`}
      media="(min-width: 1920px)"
      type="image/jpeg"
    />
    <source
      srcSet={`${imagePath}hero_1680px.webp, ${imagePath}hero_1680px@2x.webp 2x`}
      media="(min-width: 1680px)"
      type="image/webp"
    />
    <source
      srcSet={`${imagePath}hero_1680px.jpg, ${imagePath}hero_1680px@2x.jpg 2x`}
      media="(min-width: 1680px)"
      type="image/jpeg"
    />
    <source
      srcSet={`${imagePath}hero_1280px.webp, ${imagePath}hero_1280px@2x.webp 2x`}
      media="(min-width: 1200px)"
      type="image/webp"
    />
    <source
      srcSet={`${imagePath}hero_1280px.jpg, ${imagePath}hero_1280px@2x.jpg 2x`}
      media="(min-width: 1200px)"
      type="image/jpeg"
    />
    <source
      srcSet={`${imagePath}hero_1024px.webp, ${imagePath}hero_1024px@2x.webp 2x`}
      media="(min-width: 992px)"
      type="image/webp"
    />
    <source
      srcSet={`${imagePath}hero_1024px.jpg, ${imagePath}hero_1024px@2x.jpg 2x`}
      media="(min-width: 992px)"
      type="image/jpeg"
    />
    <source
      srcSet={`${imagePath}hero_768px.webp, ${imagePath}hero_768px@2x.webp 2x`}
      media="(min-width: 768px)"
      type="image/webp"
    />
    <source
      srcSet={`${imagePath}hero_768px.jpg, ${imagePath}hero_768px@2x.jpg 2x`}
      media="(min-width: 768px)"
      type="image/jpeg"
    />
    <source
      srcSet={`${imagePath}hero_480px.webp, ${imagePath}hero_480px@2x.webp 2x`}
      media="(min-width: 480px)"
      type="image/webp"
    />
    <source
      srcSet={`${imagePath}hero_480px.jpg, ${imagePath}hero_480px@2x.jpg 2x`}
      media="(min-width: 480px)"
      type="image/jpeg"
    />
    <source
      srcSet={`${imagePath}hero_375px.webp, ${imagePath}hero_375px@2x.webp 2x`}
      type="image/webp"
    />
    <source
      srcSet={`${imagePath}hero_375px.jpg, ${imagePath}hero_375px@2x.jpg 2x`}
      type="image/jpeg"
    />
    {/*
        NOTE src attribute on <img> element is intentionally left out
        to ensure that IE will render (fallback) background image!
      */}
    <img
      className={`block h-full w-full ${objectFit}`}
      srcSet={`${imagePath}hero_1680px.jpg 1680w, ${imagePath}hero_1280px.jpg 1200w, ${imagePath}hero_1024px.jpg 992w, ${imagePath}hero_768px.jpg 768w, ${imagePath}hero_480px.jpg 480w, ${imagePath}hero_375px.jpg 375w`}
      sizes="(min-width: 1680px) 1680px, 100vw"
      alt={altText}
    />
  </picture>
) : (
  <div
    className={`hero-bg-image bg-cover bg-no-repeat absolute w-full h-full z--10 ${bgColor} ${pin} ${bgPosition}`}
  />
));

export default withObjectFitSupportDetection(HeroImage);
